import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Register from "./components/Register";
import Login from "./components/Login";
import Header from "./components/Header";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import { Box } from "@mui/material";
import CadastrarUsuario from "./components/CadastrarUsuarioEvento";
import RegisterDistrital from "./components/RegisterDistrital";
import { AuthProvider } from "./context/AuthContext";
import PrivateRoute from "./components/PrivateRoute";
import LeitorQrCode from "./components/LeitorQrCode";
import ConfirmacaoConvite from "./components/ConfimacaoConvite";
import ParticipanteEvento from "./components/ParticipantesEvento";
import Convidados from "./components/Convidados";
import ListagemDistritais from "./components/ListagemDistritais";
import ImportarSympla from "./components/ImportarSympla";
import ImportarMesas from "./components/ImportarMesas";
import Sorteio from "./components/Sorteio";
import Oi from "./components/Oi";
import InscricaoPublica from "./components/InscricaoPublica";
import InscricaoInterna from "./components/InscricaoInterna";

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <Router>
          <Header />
          <Box
            component="main"
            sx={{
              minHeight: "calc(100vh - 52px)",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Routes>
              <Route path="/" element={<InscricaoPublica />} />
              <Route path="/equipe-acsp2026" element={<Login />} />
              <Route
                path="/register"
                element={
                  <PrivateRoute roles={["admin"]} element={<Register />} />
                }
              />
              <Route
                path="/cadastrarusuario"
                element={
                  <PrivateRoute
                    roles={["admin"]}
                    element={<CadastrarUsuario />}
                  />
                }
              />
              <Route
                path="/register-distrital"
                element={
                  <PrivateRoute
                    roles={["admin"]}
                    element={<RegisterDistrital />}
                  />
                }
              />
              <Route
                path="/listagem-distritais"
                element={
                  <PrivateRoute
                    roles={["admin"]}
                    element={<ListagemDistritais />}
                  />
                }
              />
              <Route
                path="/aceitar-convite/:codigoConvite"
                element={<ConfirmacaoConvite />}
              />
              <Route
                path="/convidados"
                element={
                  <PrivateRoute
                    roles={["admin", "usuario", "editor"]}
                    element={<Convidados />}
                  />
                }
              />
              <Route
                path="/listagem"
                element={
                  <PrivateRoute
                    roles={["admin", "usuario", "editor"]}
                    element={<ParticipanteEvento />}
                  />
                }
              />
              <Route
                path="/leitorqrcode"
                element={
                  <PrivateRoute
                    roles={["admin", "usuario", "editor"]}
                    element={<LeitorQrCode />}
                  />
                }
              />
              <Route
                path="/importar-sympla"
                element={
                  <PrivateRoute
                    roles={["admin"]}
                    element={<ImportarSympla />}
                  />
                }
              />
              <Route
                path="/importar-mesas"
                element={
                  <PrivateRoute
                    roles={["admin"]}
                    element={<ImportarMesas />}
                  />
                }
              />
              <Route
                path="/sorteio"
                element={
                  <PrivateRoute
                    roles={["admin", "usuario", "editor"]}
                    element={<Sorteio />}
                  />
                }
              />
              <Route
                path="/inscricao-interna"
                element={
                  <PrivateRoute
                    roles={["admin", "usuario", "editor"]}
                    element={<InscricaoInterna />}
                  />
                }
              />
              <Route path="/oi" element={<Oi />} />
            </Routes>
          </Box>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;
